(() => {
  const SELECTOR = '.thumbnail-slider .thumbnail-list.slider--tablet-up';
  const DRAG_THRESHOLD = 4;

  function isVertical(el) {
    return getComputedStyle(el).flexDirection === 'column';
  }

  function enableDragScroll(el) {
    if (el.dataset.dragScrollBound) return;
    el.dataset.dragScrollBound = 'true';

    let dragging = false;
    let moved = false;
    let startY = 0;
    let startScrollTop = 0;

    el.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !isVertical(el)) return;
      dragging = true;
      moved = false;
      startY = event.clientY;
      startScrollTop = el.scrollTop;
    });

    el.addEventListener('pointermove', (event) => {
      if (!dragging) return;
      const delta = event.clientY - startY;
      if (!moved && Math.abs(delta) > DRAG_THRESHOLD) {
        moved = true;
        el.classList.add('is-dragging');
      }
      if (moved) {
        event.preventDefault();
        el.scrollTop = startScrollTop - delta;
      }
    });

    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      el.classList.remove('is-dragging');
    };

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointerleave', endDrag);
    el.addEventListener('pointercancel', endDrag);

    el.addEventListener(
      'click',
      (event) => {
        if (!moved) return;
        moved = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  function apply(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(enableDragScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => apply());
  } else {
    apply();
  }

  document.addEventListener('shopify:section:load', (event) => apply(event.target));
})();
